<footer>
  <div class="foot-one">
    <div class="top">
      <i class="far fa-copyright"></i>
      <p>Michelle Gomes Interiors Ltd</p>
    </div>
    <div class="bottom">
      <p>Staffordshire, UK - Est 2017</p>
    </div>
  </div>
  <div class="foot-one">
    <div class="top">
      <p>Contact</p>
    </div>
    <div class="bottom">
      <p>
        <a class="email" href="mailto:hello@michellegomesinteriors.com">
          hello@michellegomesinteriors.com
        </a>
      </p>
    </div>
  </div>
  <div class="foot-one">
    <a
      href="https://www.instagram.com/michellegomesinteriors/?hl=en"
      target="_blank"
    >
      <i class="fab fa-instagram instagram"></i>
    </a>
  </div>
</footer>
